import * as Yup from "yup";
import { PHONE_NUMBER_REGEX } from "../constants";
export const newContactValidationSchema = Yup.object({
  name: Yup.string().required("Required"),
  type: Yup.string().required("Required"),

  title: Yup.string(),
  function: Yup.string(),
  phone: Yup.string().matches(
    PHONE_NUMBER_REGEX,
    "Must be a valid phone number"
  ),
  mobile: Yup.string().matches(
    PHONE_NUMBER_REGEX,
    "Must be a valid mobile number"
  ),
  email: Yup.string().email("Must be valid Email"),

  country_id: Yup.number(),
  state_id: Yup.number(),
  city: Yup.string(),
  street1: Yup.string(),
  street2: Yup.string(),
  zip: Yup.string(),
  comment: Yup.string(),
});

export const contactMainFormValidationSchema = Yup.object({
  company_type: Yup.string().min(1,"Required").required("Required"),
  name: Yup.string().required("Required"),
});

export const addContactFromValidationSchema = contactMainFormValidationSchema;
